import { thunk, action } from 'easy-peasy'
import { responseHandler, defaultHeaders } from 'utils/api'

export default {
  // request to update name first step
  requestUpdateNameState: { status: 0, payload: null },
  setRequestUpdateNameState: action((state, payload = null) => {
    state.requestUpdateNameState = payload
  }),
  requestUpdateName: thunk(async (actions, data) => {
    actions.setRequestUpdateNameState({ status: 1, payload: null })

    const response = await fetch('/api/auth/request_update/name/update_name', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        ...defaultHeaders,
        'Cache-Control': 'no-cache'
      }
    })

    const { status, payload } = await responseHandler(response)

    actions.setRequestUpdateNameState({ status, payload })
  }),

  // request to update name second step
  confirmUpdateNameState: { status: 0, payload: null },
  setConfirmUpdateNameState: action((state, payload = null) => {
    state.confirmUpdateNameState = payload
  }),
  confirmUpdateName: thunk(async (actions, data) => {
    actions.setConfirmUpdateNameState({ status: 1, payload: null })

    const response = await fetch('/api/auth/request_update/name/confirm_update_name', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        ...defaultHeaders,
        'Cache-Control': 'no-cache'
      }
    })

    const { status, payload } = await responseHandler(response)

    actions.setConfirmUpdateNameState({ status, payload })
  }),

  // request to update mobile number first step
  requestUpdateVerifyEmailState: { status: 0, payload: null },
  setRequestUpdateVerifyEmailState: action((state, payload = null) => {
    state.requestUpdateVerifyEmailState = payload
  }),
  requestUpdateVerifyEmail: thunk(async (actions, data) => {
    actions.setRequestUpdateVerifyEmailState({ status: 1, payload: null })

    const response = await fetch('/api/auth/request_update/mobile/verify_email', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { ...defaultHeaders, 'Cache-Control': 'no-cache' }
    })

    const { status, payload } = await responseHandler(response)

    actions.setRequestUpdateVerifyEmailState({ status, payload })
  }),

  // request to update mobile number second step
  requestUpdateConfirmEmailState: { status: 0, payload: null },
  setRequestUpdateConfirmEmailState: action((state, payload = null) => {
    state.requestUpdateConfirmEmailState = payload
  }),
  requestUpdateConfirmEmail: thunk(async (actions, data) => {
    actions.setRequestUpdateConfirmEmailState({ status: 1, payload: null })

    const response = await fetch('/api/auth/request_update/mobile/confirm_email', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { ...defaultHeaders, 'Cache-Control': 'no-cache' }
    })

    const { status, payload } = await responseHandler(response)
    actions.setRequestUpdateConfirmEmailState({ status, payload })
  }),

  // request to update mobile number third step
  requestUpdateMobileState: { status: 0, payload: null },
  setRequestUpdateMobileState: action((state, payload = null) => {
    state.requestUpdateMobileState = payload
  }),
  requestUpdateMobile: thunk(async (actions, data) => {
    actions.setRequestUpdateMobileState({ status: 1, payload: null })

    const response = await fetch('/api/auth/request_update/mobile/request_mobile_update', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { ...defaultHeaders, 'Cache-Control': 'no-cache' }
    })

    const { status, payload } = await responseHandler(response)

    actions.setRequestUpdateMobileState({ status, payload })
  }),

  // request to update mobile number final step
  confirmUpdateMobileState: { status: 0, payload: null },
  setConfirmUpdateMobileState: action((state, payload = null) => {
    state.confirmUpdateMobileState = payload
  }),
  confirmUpdateMobile: thunk(async (actions, data) => {
    actions.setConfirmUpdateMobileState({ status: 1, payload: null })

    const response = await fetch('/api/auth/request_update/mobile/confirm_mobile_update', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { ...defaultHeaders, 'Cache-Control': 'no-cache' }
    })

    const { status, payload } = await responseHandler(response)

    actions.setConfirmUpdateMobileState({ status, payload })
  })
}
